import { createContext, Dispatch, ReactNode, SetStateAction, useCallback, useContext, useState } from 'react';

import { GridRowId, GridRowSelectionModel } from '@mui/x-data-grid-pro';

import { ListagemProvider } from 'context/ListagemContext';
import { LojasProps, MetaProps, TipoLogisticaLojaProps } from 'pages/compra/configuracao-pedido/types';

type ConfigPedidoListContextData = {
    /** Estado da pesquisa */
    valueFilter: string;
    setValueFilter: Dispatch<SetStateAction<string>>;

    /** Estados dos filtros de lojas */
    valueFilterLojas: LojasProps[];
    setValueFilterLojas: Dispatch<SetStateAction<LojasProps[]>>;
    valueFilterMetas: MetaProps | null;
    setValueFilterMetas: Dispatch<SetStateAction<MetaProps | null>>;
    valueFilterLogisticaLoja: TipoLogisticaLojaProps[];
    setValueFilterLogisticaLoja: Dispatch<SetStateAction<TipoLogisticaLojaProps[]>>;

    /** Seleção do grid */
    selectedRows: GridRowSelectionModel;
    setSelectedRows: Dispatch<SetStateAction<GridRowSelectionModel>>;

    /** Ação de inclusão (abre modal, etc.) */
    onAdd: () => void;

    /** Ação de remoção dos itens selecionados */
    onRemove: (ids: Set<GridRowId>) => void;

    /** Flags de controle */
    addDisabled: boolean;
    removeDisabled: boolean;

    /** Configurações do campo de pesquisa */
    searchPlaceholder: string;
    showSearchField: boolean;

    /** Configurações dos filtros de lojas */
    showFilters: boolean;
};

const ConfigPedidoListContext = createContext<ConfigPedidoListContextData>({} as ConfigPedidoListContextData);

type ConfigPedidoListProviderProps = {
    children: ReactNode;
    onAdd: () => void;
    onRemove: (ids: Set<GridRowId>) => void;
    searchPlaceholder?: string;
    showSearchField?: boolean;
    showFilters?: boolean;
    addDisabled?: boolean;
    removeDisabled?: boolean;
};

export function ConfigPedidoListProvider({
    children,
    onAdd,
    onRemove,
    searchPlaceholder = '',
    showSearchField = true,
    showFilters = false,
    addDisabled = false,
    removeDisabled = false,
}: ConfigPedidoListProviderProps) {
    const [valueFilter, setValueFilter] = useState<string>('');
    const [valueFilterLojas, setValueFilterLojas] = useState<LojasProps[]>([]);
    const [valueFilterMetas, setValueFilterMetas] = useState<MetaProps | null>(null);
    const [valueFilterLogisticaLoja, setValueFilterLogisticaLoja] = useState<TipoLogisticaLojaProps[]>([]);
    const [selectedRows, setSelectedRows] = useState<GridRowSelectionModel>({ type: 'include', ids: new Set() });

    return (
        <ConfigPedidoListContext.Provider
            value={{
                valueFilter,
                setValueFilter,
                valueFilterLojas,
                setValueFilterLojas,
                valueFilterMetas,
                setValueFilterMetas,
                valueFilterLogisticaLoja,
                setValueFilterLogisticaLoja,
                selectedRows,
                setSelectedRows,

                onAdd,
                onRemove,
                addDisabled,
                removeDisabled,
                searchPlaceholder,
                showSearchField,
                showFilters,
            }}
        >
            <ListagemProvider>{children}</ListagemProvider>
        </ConfigPedidoListContext.Provider>
    );
}

export const useConfigPedidoListContext = () => useContext(ConfigPedidoListContext);
